import { useCallback, useState } from "react";
import clamp from "../utils/clamp";
export function useStepper({ totalSteps, initialStep = 0, onStepChange, }) {
    const maxStep = Math.max(0, totalSteps - 1);
    const [currentStep, setCurrentStep] = useState(() => clamp(initialStep, 0, maxStep));
    const activeStep = clamp(currentStep, 0, maxStep);
    const updateStep = useCallback((nextStep) => {
        const clamped = clamp(nextStep, 0, maxStep);
        setCurrentStep((previousStep) => {
            if (previousStep !== clamped) {
                onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange(clamped);
                return clamped;
            }
            return previousStep;
        });
    }, [maxStep, onStepChange]);
    const goNext = useCallback(() => updateStep(activeStep + 1), [activeStep, updateStep]);
    const goBack = useCallback(() => updateStep(activeStep - 1), [activeStep, updateStep]);
    return {
        currentStep: activeStep,
        isFirst: activeStep === 0,
        isLast: activeStep === maxStep,
        goNext,
        goBack,
        setStep: updateStep,
    };
}
//# sourceMappingURL=useStepper.js.map